import initCountdown from '@animalequality/countdown';

function programmedVisibility() {
  const bars = document.querySelectorAll('.announcement-bar');
  for (const bar of bars) {
    const fromAsString = bar.getAttribute('data-from');
    const from = fromAsString ? new Date(fromAsString) : null;
    const toAsString = bar.getAttribute('data-to');
    const to = toAsString ? new Date(toAsString) : null;
    const active = parseInt(bar.getAttribute('data-active'));

    if (!active) {
      // Do not show (hidden by default)
      continue;
    }

    if (from && new Date() < from) {
      // Do not show it (yet)
      continue;
    }

    if (to && new Date() > to) {
      // Don't show it anymore
      continue;
    }

    bar.classList.remove('hide');
    document.querySelector('body').classList.add('has-announcement-bar');
  }
}

function initCountdownIfExists() {
  const countdown = document.querySelector('.announcement-bar__countdown');

  if (countdown) {
    initCountdown(countdown);
  }
};

export {programmedVisibility, initCountdownIfExists};
